<template>
  <div class="ModalVideoPlayer fixed z-modalsContent modalBg modalHeight flex items-center justify-center" @click.self.stop="$emit('close')">
    <div class="relative">
      <button
        class="absolute top-16 right-16 w-32 h-32 bg-darkest flex justify-center items-center z-above"
        type="button"
        @click="$emit('close')"
      >
        <img
          alt="close"
          src="/icons/close-inv.svg"
          class="w-20 h-20"
        >
      </button>
      <video
        autoplay
        controls
        playsinline
        class="max-w-full max-h-460 testbutton"
      >
        <source :src="videoFile" type="video/mp4">
      </video>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  videoFile: string,
}>();

defineEmits<{
  (e: 'close'): void;
}>();
</script>
